import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import MainLayout from '@/common/components/layouts/MainLayout';
import ClipboardTextIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/clipboardTextIcon.svg?react';
import GalleryImportIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/galleryImportIcon.svg?react';
import SwitchTab from '@/modules/adjusterReportModules/IncidentParticipants/components/common/SwitchTab';
import FetchedImages from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/correctiveImages/components/fetchedImages/FetchedCorrectiveImages';
import InquiredCorrectiveForm from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/damaged/correctiveImages/components/inquiredForm/InquiredCorrectiveForm';
import { getDamagedVehicleCorrectiveImageTabsOpions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedVehicleCorrectiveImageTabs/getDamagedVehicleCorrectiveImageTabsOpions';
import { useCorrectiveImages } from '@/modules/adjusterReportModules/IncidentParticipants/store/correctiveImages/useCorrectiveImages';
import { useQuery } from '@tanstack/react-query';
import { useLayoutEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box } from 'styled-system/jsx';

export default () => {
  return (
    <MainLayout
      title="بازدید اولیه / تصاویر"
      header="titleHeader"
      hasBottomPadding
    >
      <InitialVisitCorrectiveImages />
    </MainLayout>
  );
};

const InitialVisitCorrectiveImages = () => {
  const [activeTab, setActiveTab] = useState(1);
  const { id, damagedId } = useParams();
  const { data: correctiveTabs = [] } = useQuery(
    getDamagedVehicleCorrectiveImageTabsOpions(+id!, +damagedId!, 'initial'),
  );
  const { reset } = useCorrectiveImages();
  const tabs = [
    {
      title: 'فرم درخواست',
      activeTabIndex: 1,
      icon: <ClipboardTextIcon stroke={'currentColor'} />,
    },
    {
      title: (
        <Box display={'flex'} alignItems={'center'} gap={'4px'}>
          <Typography
            color={activeTab === 2 ? 'purple-primary' : 'black-2'}
            textStyle={'b2'}
          >
            تصاویر دریافتی
          </Typography>
          {correctiveTabs[1]?.count > 0 && (
            <Box
              className={css({
                backgroundColor: 'purple-3',
                borderRadius: '33px',
                padding: '2px 8px',
                display: 'flex',
                alignItems: 'center',
              })}
            >
              <p className={css({ color: 'white' })}>
                {correctiveTabs[1]?.count}
              </p>
            </Box>
          )}
        </Box>
      ),
      activeTabIndex: 2,
      icon: <GalleryImportIcon stroke={'currentColor'} />,
    },
  ];
  useLayoutEffect(() => {
    reset();
  }, [id]);

  return (
    <Box mt="5.5rem">
      <TitleDescription>تصاویر درخواستی</TitleDescription>
      <Box mt="24px">
        <SwitchTab
          activeTab={1}
          tabs={tabs}
          getActiveTab={(activeTab: number) => setActiveTab(activeTab)}
        />
        {activeTab === 1 ? <InquiredCorrectiveForm type="initial" /> : null}
        {activeTab === 2 ? <FetchedImages type="initial" /> : null}
      </Box>
    </Box>
  );
};
